<template>
  <div class="component-calendar-picker">
    <label class="functional-1">
      {{ label }}
    </label>
    <b-dropdown block no-caret offset="0,8px" right ref="dropdown">
      <template #button-content>
        <span>
          {{ text }}
        </span>
        <i class="fa-light fa-angle-down pl-3 fs-18" />
      </template>

      <template>
        <div class="d-flex align-items-center justify-content-between">
          <el-select
            class="mr-3"
            v-model="month"
            popper-class="calendar-popper"
            :disabled="mode === 'today'"
          >
            <el-option
              v-for="month in monthList"
              :key="month.id"
              :value="month.id"
              :label="month.name"
            />
          </el-select>

          <el-select
            v-model="year"
            popper-class="calendar-popper"
            :disabled="mode === 'today'"
          >
            <el-option
              v-for="year in yearList"
              :key="year.id"
              :value="year.id"
              :label="year.name"
            />
          </el-select>

          <button
            class="btn btn-control-date mx-3"
            :disabled="mode === 'today'"
            @click="subtractMonth"
          >
            <i class="fa fa-angle-left" />
          </button>
          <button
            class="btn btn-control-date"
            :disabled="mode === 'today'"
            @click="addMonth"
          >
            <i class="fa fa-angle-right" />
          </button>
        </div>

        <div class="d-flex justify-content-between my-3">
          <b-form-radio
            v-model="mode"
            button
            value="today"
            button-variant="outline-primary"
            @change="changeMode"
          >
            Hoje
          </b-form-radio>
          <b-form-radio
            v-model="mode"
            button
            value="day"
            class="mx-3"
            button-variant="outline-primary"
            @change="changeMode"
          >
            Dia
          </b-form-radio>
          <b-form-radio
            v-model="mode"
            button
            value="period"
            button-variant="outline-primary"
            @change="changeMode"
          >
            Período
          </b-form-radio>
        </div>

        <div class="d-flex justify-content-center">
          <table>
            <thead>
              <th
                v-for="(day, i) in ['D', 'S', 'T', 'Q', 'Q', 'S', 'S']"
                class="py-3"
                :key="i"
              >
                {{ day }}
              </th>
            </thead>
            <tbody>
              <tr v-for="(line, i) in lines" :key="i">
                <td
                  v-for="(day, i) in dayList.slice(line.start, line.end)"
                  :key="i"
                  :class="{
                    weekend: !i || i === 6,
                    between: isBeforeEnd(day)
                  }"
                  @mouseover="setLastHovered(day)"
                  @mouseleave="lastHovered = null"
                >
                  <button
                    class="btn"
                    :disabled="isBeforeStart(day) || mode === 'today'"
                    :class="[
                      {
                        current: day.isCurrentMonth,
                        selected: isSelected(day)
                      }
                    ]"
                    @click="selectDay(day)"
                  >
                    {{ day.day }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="row mt-5">
          <div class="col-6 pr-3">
            <button class="btn btn-block btn-outline-secondary" @click="clear">
              Limpar
            </button>
          </div>
          <div class="col-6 pl-3">
            <button
              class="btn btn-block btn-new-primary"
              :disabled="!isValid"
              @click="apply"
            >
              Aplicar
            </button>
          </div>
        </div>
      </template>
    </b-dropdown>
  </div>
</template>
<script>
import { MAP_MONTH_NAME } from "@/constants/date";
import {
  datesString,
  getArrayOfDaysInMonth,
  getYearRange
} from "@/functions/helpers";
import { Option, Select } from "element-ui";
import moment from "moment";

const DATE_SHAPE = "YYYY-MM-DD";
export default {
  components: {
    "el-select": Select,
    "el-option": Option
  },
  props: {
    value: {
      type: Array,
      default: () => ["", ""]
    },
    placeholder: {
      type: String,
      default: "Selecione o período"
    },
    label: {
      type: String,
      default: "Período"
    }
  },
  data() {
    return {
      mode: "period",
      month: new Date().getMonth() + 1,
      year: new Date().getFullYear(),
      lines: [
        { start: 0, end: 7 },
        { start: 7, end: 14 },
        { start: 14, end: 21 },
        { start: 21, end: 28 },
        { start: 28, end: 35 },
        { start: 35, end: 42 }
      ],

      startDay: this.value[0],
      endDay: this.value[1],
      lastHovered: null
    };
  },
  computed: {
    text() {
      return this.value[0] && this.value[1]
        ? datesString(this.value)
        : this.placeholder;
    },
    monthList() {
      return Object.entries(MAP_MONTH_NAME).map(([_, { name, refNumber }]) => ({
        id: refNumber,
        name
      }));
    },
    yearList() {
      const currentYear = new Date().getFullYear();
      return [...getYearRange(currentYear + 10, currentYear - 20, -1)]
        .sort()
        .map(y => ({ id: y, name: y }));
    },
    dayList() {
      return getArrayOfDaysInMonth(this.year, this.month);
    },
    isValid() {
      return !!this.startDay && !!this.endDay;
    }
  },
  methods: {
    addMonth() {
      if (this.month === 12) {
        this.month = 1;
        this.year++;
      } else {
        this.month++;
      }
    },
    subtractMonth() {
      if (this.month === 1) {
        this.month = 12;
        this.year--;
      } else {
        this.month--;
      }
    },
    changeMode(v) {
      if (v === "today") {
        this.month = new Date().getMonth() + 1;
        this.year = new Date().getFullYear();
        this.startDay = this.endDay = moment(new Date()).format(DATE_SHAPE);
      } else {
        this.startDay = this.endDay = "";
      }
    },
    selectDay(data) {
      let date = this.getDay(data);

      if (this.mode === "day") {
        this.startDay = this.endDay = date;
        return;
      }

      if (this.startDay && this.endDay) {
        this.startDay = this.endDay = "";
        return;
      }

      this.startDay ? (this.endDay = date) : (this.startDay = date);
    },
    getDay(data) {
      let day, month, year;
      day = data.day;

      if (data.isCurrentMonth) {
        month = this.month;
        year = this.year;
      } else {
        if (data.monthPosition === "next") {
          if (this.month === 12) {
            year = this.year + 1;
            month = 1;
          } else {
            year = this.year;
            month = this.month + 1;
          }
        } else {
          if (this.month === 1) {
            year = this.year - 1;
            month = 12;
          } else {
            year = this.year;
            month = this.month - 1;
          }
        }
      }

      return `${year}-${month}-${day}`;
    },
    setLastHovered(data) {
      let value = this.getDay(data);
      this.lastHovered = value;
    },
    clear() {
      this.startDay = this.endDay = "";
      this.apply();
    },
    apply() {
      this.$emit("input", [this.startDay, this.endDay]);
      this.$refs.dropdown.hide();
    },

    // Button state
    isSelected(data) {
      let value = this.getDay(data);
      return value === this.startDay || value === this.endDay;
    },
    isBeforeStart(data) {
      if (this.mode === "day") return;

      let value = this.getDay(data);
      return (
        !!this.startDay &&
        moment(value, DATE_SHAPE).isBefore(moment(this.startDay, DATE_SHAPE))
      );
    },
    isBeforeEnd(data) {
      if (this.startDay) {
        let start = moment(this.startDay, DATE_SHAPE);
        let end = moment(this.endDay || this.lastHovered, DATE_SHAPE);
        let value = moment(this.getDay(data), DATE_SHAPE);

        return value.isBetween(start, end);
      }
    }
  },
  mounted() {
    if (!!this.value[0] && this.value[0] === this.value[1]) {
      this.mode =
        this.value[0] === moment(new Date()).format(DATE_SHAPE)
          ? "today"
          : "day";
    }
  }
};
</script>
<style lang="scss" scoped>
.component-calendar-picker {
  position: relative;
  ::v-deep {
    .b-dropdown {
      .dropdown-toggle {
        display: flex;
        font-size: 14px;
        min-height: 40px;
        padding: 8px 12px;
        border-radius: 4px;
        justify-content: space-between;
        align-items: center;
        font-weight: normal;
        color: #5a5466;
        background-color: unset;
        border: 1px solid #a9a9a9;
      }
      .dropdown-menu {
        padding: 8px 16px;
        border-radius: 4px;
        border: 1px solid rgba(219, 221, 230, 0.85);
        box-shadow: 0px 0px 40px 0px rgba(0, 0, 0, 0.08);
      }
    }
    .btn-group-toggle {
      .btn,
      .btn-outline-primary {
        padding: 4px 8px;
        min-height: 28px;
        font-size: 10px;
        height: 28px;
        width: 86px;
      }
      .btn-outline-primary:not(:hover, :active, :has(input:checked)) {
        font-weight: 500;
        color: #77788edd;
        border: 1px solid var(--l-neutral-113, rgba(219, 221, 230, 0.85));
      }
    }
    .el-select {
      .el-input__inner {
        width: 100px;
        height: 40px;
        border: none;
        padding-left: 8px;
        padding-right: 24px;
        min-height: 40px;
      }
      .el-input__suffix {
        right: 0;
      }
    }
  }
  .btn-control-date {
    padding: 0;
    height: 28px;
    aspect-ratio: 1;
    min-height: 24px;
    color: #b68af8;
    border-radius: 23px;
    background: #f7f7f9;
  }
  table {
    th {
      color: #595463;
      text-align: center;
    }
    td {
      transition: 0.2s all;
      button {
        padding: 0;
        width: 32px;
        height: unset;
        aspect-ratio: 1;
        min-height: unset;
        font-weight: unset;
        transition: 0.2s all;
        &:not(.current) {
          color: #b8baccda;
        }
        &:hover {
          background: #b8baccda;
        }
        &:active,
        &.selected {
          background: var(--primary);
          color: white;
        }
      }
      &.weekend {
        background-color: #d7d7d73d;
        button {
          color: #b8baccda;
        }
      }
      &.between {
        background-color: #e6d5ffd9;
      }
    }
  }
  .row {
    .btn {
      height: 40px;
      min-height: 40px;
    }
  }
}
</style>
